import { render, staticRenderFns } from "./DataInline.vue?vue&type=template&id=35bd52ee"
import script from "./DataInline.vue?vue&type=script&lang=js"
export * from "./DataInline.vue?vue&type=script&lang=js"
import style0 from "./DataInline.vue?vue&type=style&index=0&id=35bd52ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports